var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowBrandRecommend
    ? _c(
        "div",
        { staticClass: "brand-recommend-border" },
        [
          _c("el-divider"),
          _vm._v(" "),
          _c("div", { staticClass: "brand-recommend-title" }, [
            _c("div", { staticClass: "info" }, [
              _vm.queryData.collectionBrandId !== "" &&
              _vm.queryData.collectionBrandId !== null
                ? _c(
                    "div",
                    {
                      staticClass: "brand-content",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c("img", {
                        staticStyle: {
                          height: "50px",
                          width: "50px",
                          float: "left",
                          border: "1px solid #e6e6e6",
                          "border-radius": "50%",
                          cursor: "pointer"
                        },
                        attrs: { src: _vm.queryData.collectionBrandLogoUrl },
                        on: { click: _vm.gotoBrand }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "collection_brand" }, [
                        _c("div", { staticClass: "brand_name_rating" }, [
                          _c(
                            "a",
                            {
                              staticStyle: {
                                "font-size": "16px",
                                color: "#262b2f",
                                "text-decoration": "underline",
                                "font-weight": "500",
                                "line-height": "35px",
                                "margin-left": "10px",
                                float: "left",
                                cursor: "pointer"
                              },
                              attrs: { href: "javascript:void(0)" },
                              on: { click: _vm.gotoBrand }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.queryData.collectionBrandName) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.queryData["rating"]
                            ? _c(
                                "div",
                                {
                                  staticClass: "total-reviews",
                                  on: { click: _vm.showRating }
                                },
                                [
                                  _c("el-rate", {
                                    staticStyle: {
                                      width: "85px",
                                      "margin-top": "-5px"
                                    },
                                    attrs: {
                                      disabled: "",
                                      allowHalf: true,
                                      "disabled-void-color": "#000",
                                      "disabled-void-icon-class":
                                        "el-icon-star-off",
                                      colors: _vm.colors,
                                      "text-color": "#262B2F"
                                    },
                                    model: {
                                      value: _vm.queryData["rating"],
                                      callback: function($$v) {
                                        _vm.$set(_vm.queryData, "rating", $$v)
                                      },
                                      expression: "queryData['rating']"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "ratingStr" }, [
                                    _vm._v(_vm._s(_vm.queryData["ratingStr"]))
                                  ]),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "el-icon-arrow-down",
                                    staticStyle: { "margin-top": "-5px" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.queryData["brandIsVilocal"]
                            ? _c("div", { staticClass: "brand-vilocal" }, [
                                _vm._v("ViLocal")
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        (!_vm.isMobile || _vm.isIpad) &&
                        _vm.queryData.collectionBrandSellingPoint &&
                        _vm.queryData.collectionBrandId !== "" &&
                        _vm.queryData.collectionBrandId !== null
                          ? _c("div", { staticClass: "selling-point" }, [
                              _vm._v(
                                "\n                (" +
                                  _vm._s(
                                    _vm.queryData.collectionBrandSellingPoint
                                  ) +
                                  ")\n            "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            !_vm.isMobile
              ? _c(
                  "div",
                  {
                    staticClass: "brand-recommend-more",
                    on: {
                      click: function($event) {
                        return _vm.gotoBrand()
                      }
                    }
                  },
                  [
                    _vm._v("Shop All "),
                    _c("span", [_vm._v(_vm._s(_vm.productTotal))]),
                    _vm._v("Products")
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.showRatingDialog && !_vm.isMobile
            ? _c(
                "div",
                {
                  ref: "ratingCollection",
                  staticClass: "rating-collection-pc"
                },
                [
                  _c(
                    "p",
                    [
                      _c("span", [_vm._v("Product Quality")]),
                      _vm._v(" "),
                      _c("el-rate", {
                        attrs: {
                          disabled: "",
                          allowHalf: true,
                          colors: _vm.colors,
                          "disabled-void-color": "#000",
                          "disabled-void-icon-class": "el-icon-star-off",
                          "text-color": "#262B2F"
                        },
                        model: {
                          value: _vm.queryData["descriptionRating"],
                          callback: function($$v) {
                            _vm.$set(_vm.queryData, "descriptionRating", $$v)
                          },
                          expression: "queryData['descriptionRating']"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "rating" }, [
                        _vm._v(_vm._s(_vm.queryData["productQuality"]))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c("span", [_vm._v(" Brand Service")]),
                      _vm._v(" "),
                      _c("el-rate", {
                        attrs: {
                          disabled: "",
                          allowHalf: true,
                          colors: _vm.colors,
                          "disabled-void-color": "#000",
                          "disabled-void-icon-class": "el-icon-star-off",
                          "text-color": "#262B2F"
                        },
                        model: {
                          value: _vm.queryData["serviceRating"],
                          callback: function($$v) {
                            _vm.$set(_vm.queryData, "serviceRating", $$v)
                          },
                          expression: "queryData['serviceRating']"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "rating" }, [
                        _vm._v(_vm._s(_vm.queryData["brandServiceStr"]))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c("span", [_vm._v(" Logistics Rating")]),
                      _vm._v(" "),
                      _c("el-rate", {
                        attrs: {
                          disabled: "",
                          allowHalf: true,
                          colors: _vm.colors,
                          "disabled-void-color": "#000",
                          "disabled-void-icon-class": "el-icon-star-off",
                          "text-color": "#262B2F"
                        },
                        model: {
                          value: _vm.queryData["logisticsRating"],
                          callback: function($$v) {
                            _vm.$set(_vm.queryData, "logisticsRating", $$v)
                          },
                          expression: "queryData['logisticsRating']"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "rating" }, [
                        _vm._v(_vm._s(_vm.queryData["logisticsRatingStr"]))
                      ])
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isMobile
            ? _c("div", { staticClass: "ships-free" }, [
                _vm.queryData.collectionBrandId !== "" &&
                _vm.queryData.collectionBrandId !== null
                  ? _c("div", { staticClass: "m-title" }, [
                      _c("div", { staticClass: "m-title-logo" }, [
                        _c("img", {
                          staticStyle: {
                            height: "45px",
                            width: "45px",
                            float: "left",
                            border: "1px solid #e6e6e6",
                            "border-radius": "50%",
                            cursor: "pointer"
                          },
                          attrs: { src: _vm.queryData.collectionBrandLogoUrl },
                          on: { click: _vm.gotoBrand }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "m-title-text",
                          staticStyle: { position: "relative", top: "-10px" }
                        },
                        [
                          _c("div", [
                            _c(
                              "a",
                              {
                                staticStyle: {
                                  "font-size": "16px",
                                  color: "#262b2f",
                                  "font-weight": "500",
                                  cursor: "pointer",
                                  "font-family": "Satoshi-Medium",
                                  "text-decoration": "none"
                                },
                                attrs: { href: "javascript:void(0)" },
                                on: { click: _vm.gotoBrand }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.queryData.collectionBrandName)
                                )
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.queryData["rating"]
                        ? _c(
                            "div",
                            {
                              staticClass: "total-reviews",
                              on: { click: _vm.showRating }
                            },
                            [
                              _c("el-rate", {
                                staticStyle: { width: "80px" },
                                attrs: {
                                  disabled: "",
                                  allowHalf: true,
                                  colors: _vm.colors,
                                  "disabled-void-color": "#000",
                                  "disabled-void-icon-class":
                                    "el-icon-star-off",
                                  "text-color": "#262B2F"
                                },
                                model: {
                                  value: _vm.queryData["rating"],
                                  callback: function($$v) {
                                    _vm.$set(_vm.queryData, "rating", $$v)
                                  },
                                  expression: "queryData['rating']"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "ratingStr" }, [
                                _vm._v(_vm._s(_vm.queryData["ratingStr"]))
                              ]),
                              _vm._v(" "),
                              _c("i", { staticClass: "el-icon-arrow-down" }),
                              _vm._v(" "),
                              _vm.showRatingDialog
                                ? _c(
                                    "div",
                                    {
                                      ref: "ratingCollection",
                                      staticClass: "rating-collection"
                                    },
                                    [
                                      _c(
                                        "p",
                                        [
                                          _c("span", [
                                            _vm._v("Product Quality")
                                          ]),
                                          _vm._v(" "),
                                          _c("el-rate", {
                                            attrs: {
                                              disabled: "",
                                              allowHalf: true,
                                              colors: _vm.colors,
                                              "disabled-void-color": "#000",
                                              "disabled-void-icon-class":
                                                "el-icon-star-off",
                                              "text-color": "#262B2F"
                                            },
                                            model: {
                                              value:
                                                _vm.queryData[
                                                  "descriptionRating"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.queryData,
                                                  "descriptionRating",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryData['descriptionRating']"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "rating" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.queryData[
                                                    "productQuality"
                                                  ]
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        [
                                          _c("span", [
                                            _vm._v(" Brand Service")
                                          ]),
                                          _vm._v(" "),
                                          _c("el-rate", {
                                            attrs: {
                                              disabled: "",
                                              allowHalf: true,
                                              colors: _vm.colors,
                                              "disabled-void-color": "#000",
                                              "disabled-void-icon-class":
                                                "el-icon-star-off",
                                              "text-color": "#262B2F"
                                            },
                                            model: {
                                              value:
                                                _vm.queryData["serviceRating"],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.queryData,
                                                  "serviceRating",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryData['serviceRating']"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "rating" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.queryData[
                                                    "brandServiceStr"
                                                  ]
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        [
                                          _c("span", [
                                            _vm._v(" Logistics Rating")
                                          ]),
                                          _vm._v(" "),
                                          _c("el-rate", {
                                            attrs: {
                                              disabled: "",
                                              allowHalf: true,
                                              colors: _vm.colors,
                                              "disabled-void-color": "#000",
                                              "disabled-void-icon-class":
                                                "el-icon-star-off",
                                              "text-color": "#262B2F"
                                            },
                                            model: {
                                              value:
                                                _vm.queryData[
                                                  "logisticsRating"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.queryData,
                                                  "logisticsRating",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryData['logisticsRating']"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "rating" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.queryData[
                                                    "logisticsRatingStr"
                                                  ]
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.queryData["brandIsVilocal"]
                        ? _c("div", { staticClass: "brand-vilocal" }, [
                            _vm._v("ViLocal")
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.queryData.collectionBrandId !== "" &&
                _vm.queryData.collectionBrandId !== null &&
                _vm.queryData.collectionBrandSellingPoint &&
                _vm.isMobile
                  ? _c("div", { staticClass: "selling-point" }, [
                      _vm._v(
                        "(" +
                          _vm._s(_vm.queryData.collectionBrandSellingPoint) +
                          ")"
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("CardCom", {
            attrs: {
              data: _vm.list,
              type: _vm.type,
              isShowBrandTag: false,
              isShowAddToCart: false
            },
            on: { buryingPoint: _vm.buryingPoint }
          }),
          _vm._v(" "),
          _vm.isMobile
            ? _c(
                "div",
                {
                  staticClass: "brand-recommend-more",
                  on: {
                    click: function($event) {
                      return _vm.gotoBrand()
                    }
                  }
                },
                [
                  _vm._v("Shop All "),
                  _c("span", [_vm._v(_vm._s(_vm.productTotal))]),
                  _vm._v("Products")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-divider")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4786c469", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4786c469","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/detail/recommend/brand-recommend.vue
// module id = null
// module chunks = 